import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import './AlphaVideo.css';

class AlphaVideo extends Component {
  constructor(props) {
    super(props);

    this.interval = null;

    this.videoRef = React.createRef();
    this.bufferRef = React.createRef();
    this.outputRef = React.createRef();

    this.buffer = null;
    this.output = null;
  }

  processFrame = () => {
    const { width, height } = this.props;

    this.buffer.drawImage(this.videoRef.current, 0, 0);

    const image = this.buffer.getImageData(0, 0, width, height);
    const imageData = image.data;
    const alphaData = this.buffer.getImageData(0, height, width, height).data;

    for (let i = 3, len = imageData.length; i < len; i = i + 4) {
      imageData[i] = alphaData[i - 1];
    }

    this.output.putImageData(image, 0, 0, 0, 0, width, height);
  };

  playEventListener = () => {
    const { frameLength } = this.props;

    clearInterval(this.interval);
    this.interval = setInterval(this.processFrame, frameLength);
  };

  endedEventListener = () => {
    const { onVideoStop } = this.props;

    clearInterval(this.interval);
    onVideoStop();
    this.setState({ hasFinished: true });
  };

  componentDidMount() {
    const { casinoSoundsOn, mute } = this.props;

    this.buffer = this.bufferRef.current.getContext('2d');
    this.output = this.outputRef.current.getContext('2d');

    this.videoRef.current.addEventListener('play', this.playEventListener);
    this.videoRef.current.addEventListener('ended', this.endedEventListener);
    this.videoRef.current.muted = mute || !casinoSoundsOn;
    this.videoRef.current.play();
  }

  componentDidUpdate(prevProps) {
    const { casinoSoundsOn, mute } = this.props;

    this.videoRef.current.muted = mute || !casinoSoundsOn;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.videoRef.current.pause();

    this.buffer = null;
    this.output = null;

    this.videoRef.current.removeEventListener('play', this.playEventListener);
    this.videoRef.current.removeEventListener('ended', this.endedEventListener);
  }

  render() {
    const { width, height, src } = this.props;

    return (
      <div className="alpha-video-scene">
        <video playsInline ref={this.videoRef} id="alpha-video-video">
          <source src={src} type="video/mp4" />
        </video>
        <canvas
          ref={this.bufferRef}
          width={width}
          height={height * 2}
          className="alpha-video-buffer"
        />
        <canvas
          ref={this.outputRef}
          width={width}
          height={height}
          className="alpha-video-output"
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  casinoSoundsOn: makeSelectCasinoSoundsOn()
});

AlphaVideo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  src: PropTypes.string.isRequired,
  frameLength: PropTypes.number,
  onVideoStop: PropTypes.func
};

AlphaVideo.defaultProps = {
  width: 280,
  height: 267,
  frameLength: 40,
  onVideoStop: () => {}
};

export default connect(mapStateToProps)(AlphaVideo);
